import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { ViewState } from "../../../common/config/AppConstants";
import * as format from "../../../common/FormatFunctions";
import { ListValueDisplay } from "../../Common/ListValueDisplay";
import * as log from "../../../common/Feedback/Log";
import { PartDisplay } from "../../Products/legacy/UI/PartDisplay";
import { ProductDisplay } from "../../Products/legacy/UI/ProductDisplay";
export class FlowItemDisplay extends React.Component {
  setUpPartColumns = () => {
    let localCols = [];
    localCols.push(pr.getTableColumn("name", "Name"));
    localCols.push(pr.getTableColumn("shortDescription", "Description"));
    localCols.push(pr.getTableColumn("operationalType", "Type"));

    return localCols;
  };

  setUpProductColumns = () => {
    let localCols = [];
    localCols.push(pr.getTableColumn("name", "Name"));
    localCols.push(pr.getTableColumn("shortDescription", "Description"));
    localCols.push(pr.getTableColumn("operationalType", "Type"));

    return localCols;
  };

  render() {
    var bean = this.props.data;
    log.info(bean);
    if (!format.isNotNull(bean)) {
      return <div></div>;
    }
    return (
      <div>
        <div className="ui-g-12 card">
          <div className="ui-g-12">
            {/*Empty div for spacing*/}
            <label />
          </div>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>Name: </b>
              <label>{bean.name || "Not Set"}</label>
            </div>
            <div className="ui-g-6">
              <b>Short Description: </b>
              <label>{bean.shortdDescription || "Not Set"}</label>
            </div>
          </div>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>Sequence: </b>
              <label>{bean.sequence || "Not Set"}</label>
            </div>

            <div className="ui-g-6">
              <b>Station: </b>
              <label>{bean.toolId || "Not Set"}</label>
            </div>
          </div>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>Notes: </b>
              <label>{bean.notes || "Not Set"}</label>
            </div>
            <div className="ui-g-6">
              <b>Status : </b>
              <label>{this.getStatus(bean)}</label>
            </div>
          </div>

          <React.Fragment>
            <h3>Inputs</h3>

            {this.getInputParts(bean)}
            <div></div>
            {this.getInputProducts(bean)}
            <h3>Outputs</h3>
            {this.getOutputParts(bean)}
            <div></div>
            {this.getOutputProducts(bean)}
          </React.Fragment>
        </div>
      </div>
    );
  }

  getStatus = bean => {
    if (!format.isNotNull(bean.statusList)) {
      return <div> </div>;
    }
    var statusRepresentation = "";
    bean.statusList.forEach(element => {
      if (statusRepresentation === "") {
        statusRepresentation = element;
      } else {
        statusRepresentation = statusRepresentation + ", " + element;
      }
    });

    return <label> {statusRepresentation} </label>;
  };
  getInputParts = bean => {
    if (!format.isNotNull(bean.inputPartList)) {
      return <React.Fragment></React.Fragment>;
    }

    let columns = this.setUpPartColumns().map((col, i) => {
      return (
        <pr.Column
          key={col.field}
          field={col.field}
          header={col.header}
          // sortable={col.sortable}
          // filter={col.filter}
          // filterMatchMode={col.filterMatchMode}
          style={col.style}
        />
      );
    });

    return (
      <React.Fragment>
        {"Parts"}
        <pr.DataTable
          ref={el => {
            this.dt = el;
          }}
          reorderableColumns={false}
          selectionMode="single"
          onSelectionChange={e => {}}
          value={bean.inputPartList}
          dataKey="id"
          emptyMessage="No Properties"
          // header={
          //   <div>
          //     <label className="header-label">Accepted Values</label>
          //   </div>
          // }
          rows={100}
          autoLayout={true}
        >
          {columns}
          <pr.Column
            key="view"
            body={this.getPartViewTemplate}
            style={{ textAlign: "center", width: "8em" }}
          />
        </pr.DataTable>
      </React.Fragment>
    );
    // var componentArray = [];
    // var index = 0;
    // bean.inputPartList.forEach(element => {
    //   componentArray[index] = (
    //     <PartDisplay key={"PartInput" + index} data={element} />
    //   );
    // });

    // return componentArray;
  };
  getInputProducts = bean => {
    if (!format.isNotNull(bean.inputProductList)) {
      return <React.Fragment></React.Fragment>;
    }
    let columns = this.setUpProductColumns().map((col, i) => {
      return (
        <pr.Column
          key={col.field}
          field={col.field}
          header={col.header}
          // sortable={col.sortable}
          // filter={col.filter}
          // filterMatchMode={col.filterMatchMode}
          style={col.style}
        />
      );
    });

    return (
      <React.Fragment>
        {"Products"}
        <pr.DataTable
          ref={el => {
            this.dt = el;
          }}
          reorderableColumns={false}
          selectionMode="single"
          onSelectionChange={e => {}}
          value={bean.inputProductList}
          dataKey="id"
          emptyMessage="No Properties"
          // header={
          //   <div>
          //     <label className="header-label">Accepted Values</label>
          //   </div>
          // }
          rows={100}
          autoLayout={true}
        >
          {columns}
          <pr.Column
            key="view"
            body={this.getProductViewTemplate}
            style={{ textAlign: "center", width: "8em" }}
          />
        </pr.DataTable>
      </React.Fragment>
    );
    // var componentArray = [];
    // var index = 0;
    // bean.inputProductList.forEach(element => {
    //   componentArray[index] = (
    //     <ProductDisplay key={"ProductInput" + index} data={element} />
    //   );
    // });

    // return componentArray;
  };
  getOutputParts = bean => {
    if (!format.isNotNull(bean.outputPartList)) {
      return <React.Fragment></React.Fragment>;
    }
    let columns = this.setUpPartColumns().map((col, i) => {
      return (
        <pr.Column
          key={col.field}
          field={col.field}
          header={col.header}
          // sortable={col.sortable}
          // filter={col.filter}
          // filterMatchMode={col.filterMatchMode}
          style={col.style}
        />
      );
    });

    return (
      <React.Fragment>
        {"Parts"}
        <pr.DataTable
          ref={el => {
            this.dt = el;
          }}
          reorderableColumns={false}
          selectionMode="single"
          onSelectionChange={e => {}}
          value={bean.outputPartList}
          dataKey="id"
          emptyMessage="No Properties"
          // header={
          //   <div>
          //     <label className="header-label">Accepted Values</label>
          //   </div>
          // }
          rows={100}
          autoLayout={true}
        >
          {columns}
          <pr.Column
            key="view"
            body={this.getPartViewTemplate}
            style={{ textAlign: "center", width: "8em" }}
          />
        </pr.DataTable>
      </React.Fragment>
    );
    // var componentArray = [];
    // var index = 0;
    // bean.outputPartList.forEach(element => {
    //   componentArray[index] = (
    //     <PartDisplay key={"PartOuput" + index} data={element} />
    //   );
    // });

    // return componentArray;
  };
  getOutputProducts = bean => {
    if (!format.isNotNull(bean.outputProductList)) {
      return <React.Fragment></React.Fragment>;
    }
    let columns = this.setUpProductColumns().map((col, i) => {
      return (
        <pr.Column
          key={col.field}
          field={col.field}
          header={col.header}
          // sortable={col.sortable}
          // filter={col.filter}
          // filterMatchMode={col.filterMatchMode}
          style={col.style}
        />
      );
    });

    return (
      <React.Fragment>
        {"Products"}
        <pr.DataTable
          ref={el => {
            this.dt = el;
          }}
          reorderableColumns={false}
          selectionMode="single"
          onSelectionChange={e => {}}
          value={bean.outputProductList}
          dataKey="id"
          emptyMessage="No Properties"
          // header={
          //   <div>
          //     <label className="header-label">Accepted Values</label>
          //   </div>
          // }
          rows={100}
          autoLayout={true}
        >
          {columns}
          <pr.Column
            key="view"
            body={this.getProductViewTemplate}
            style={{ textAlign: "center", width: "8em" }}
          />
        </pr.DataTable>
      </React.Fragment>
    );
    // var componentArray = [];
    // var index = 0;
    // bean.outputProductList.forEach(element => {
    //   componentArray[index] = (
    //     <ProductDisplay key={"ProductOutput" + index} data={element} />
    //   );
    // });

    // return componentArray;
  };
  getPartViewTemplate = (rowData, column) => {
    return (
      <pr.Button
        type="button"
        icon="pi pi-ellipsis-h"
        className="p-button-success"
        onClick={() => {}}
        // onClick={() => {
        //   this.setState({ partSelected: rowData, partAdded: true });
        // }}
        style={{ marginRight: ".5em", background: "green" }}
      ></pr.Button>
    );
  };

  getProductViewTemplate = (rowData, column) => {
    return (
      <pr.Button
        type="button"
        icon="pi pi-ellipsis-h"
        className="p-button-success"
        onClick={() => {}}
        // onClick={() => {
        //   this.setState({ partSelected: rowData, partAdded: true });
        // }}
        style={{ marginRight: ".5em", background: "green" }}
      ></pr.Button>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Flows/UI/FlowItemDisplay.js